import { Controller } from "@hotwired/stimulus";
import { Calendar } from "@fullcalendar/core";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import listPlugin from '@fullcalendar/list'
import deLocale from '@fullcalendar/core/locales/de'

const LOCALE_MAP = {
  de: deLocale,
}

export default class extends Controller {
  static values = {
    events: Array,
    locale: { type: String, default: 'de' },
  };

  connect() {
    this.calendar = new Calendar(this.element, {
      plugins: [dayGridPlugin, timeGridPlugin, listPlugin],
      initialView: "dayGridMonth",
      events: this.eventsValue,
      locale: LOCALE_MAP[this.localeValue] || this.localeValue,
      eventColor: '#016973',
      fixedWeekCount: true,
      headerToolbar: {
        left: 'prev,next today',
        center: 'title',
        right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek',
      },
      themeSystem: 'standard',
    });

    this.calendar.render();
  }

  disconnect() {
    this.calendar.destroy();
  }
}
